import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { lighten, makeStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import DeleteIcon from '@material-ui/icons/Delete';
import SyncIcon from '@material-ui/icons/Sync';
import LaunchIcon from '@material-ui/icons/Launch';
import LibraryAddIcon from '@material-ui/icons/LibraryAdd';
import StarIcon from '@material-ui/icons/Star';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';

import { Framework } from '@flint/framework';

const handleAddEPub = () => {
    Framework.redirect(`/add-epub`);
}

const useToolbarStyles = makeStyles((theme) => ({
    root: {
        paddingLeft: theme.spacing(2.5),
        paddingRight: theme.spacing(2.5),
    },
    highlight:
        theme.palette.type === 'light'
            ? {
                color: theme.palette.secondary.main,
                backgroundColor: lighten(theme.palette.secondary.light, 0.85),
            }
            : {
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.secondary.dark,
            },
    title: {
        flex: '1 1 100%',
        fontFamily: "Merriweather",
        fontStyle: "normal",
        fontWeight: "bold",
        fontSize: "28px",
        lineHeight: "90px",
        color: "#222747",
    },
    selectedText: {
        flex: '1 1 100%',
        fontFamily: "Merriweather",
        fontStyle: "normal",
        fontWeight: "bold",
        fontSize: "18px",
        color: "#222747",
    },
    addIcon: {
        height: "28px",
        width: "28px",
    },
    searchForm: {
        width: "100%",
        padding: theme.spacing(2),
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
    },
    searchButton: {
        color: "#FFF",
        padding: "15px",
        fontSize: "18px",
        fontFamily: "Nunito Sans",
        fontStyle: "normal",
        fontWeight: "bold",
        lineHeight: "20px",
        background: "#222747",
        borderRadius: "3px",
        textTransform: "unset",
        transition: "background 0.25s",
        border: "2px solid #222747",
        "&:hover": {
            background: "none",
            color: "#222747",
        },
        width: "100%",
    },
    formControl: {
        width: "100%",

    },
    searchInput: {
        width: "100%",
    },
    gridItem: {
        margin: theme.spacing(1),
    }
}));

const EnhancedTableToolbar = (props) => {
    const classes = useToolbarStyles();
    const { numSelected, filter, searchTerm, handleSearchEPub, handleSearchFilter, handleSearchSubmit, handleDeleteEPub, handleSyncEPub, clearSearchFilter, handleReUploadEPub, handleSyncAllEPub, handleFeatureEpub, featured, handleViewTopics } = props;

    return (
        <>
            <Grid container wrap="wrap" alignItems="center" justify="space-between">
                <form className={classes.searchForm} onSubmit={handleSearchSubmit}>
                    <Grid item xs={12} sm={2} className={classes.gridItem}><FormControl variant="outlined" className={classes.formControl}>
                        <InputLabel id="select-search-filter-label">Search Filter</InputLabel>
                        <Select
                            labelId="select-search-filter-label"
                            id="select-search-filter"
                            value={filter}
                            onChange={handleSearchFilter}
                            label="Search Filter"
                        >
                            <MenuItem value="All">All</MenuItem>
                            <MenuItem value="isbn">ISBN</MenuItem>
                            <MenuItem value="title">Title</MenuItem>
                            <MenuItem value="author">Author</MenuItem>
                            <MenuItem value="publisher">Publisher</MenuItem>
                        </Select>
                    </FormControl></Grid>
                    <Grid item xs={12} sm={4} md={5} className={classes.gridItem}><TextField id="search-term" label="Search" variant="outlined" onChange={handleSearchEPub} className={classes.searchInput} value={searchTerm} /></Grid>
                    <Grid item xs={12} sm={2} className={classes.gridItem}><Button type="submit" variant="contained" className={classes.searchButton}>Search</Button></Grid>
                    <Grid item xs={12} sm={2} className={classes.gridItem}><Button onClick={clearSearchFilter} variant="contained" className={classes.searchButton}>Clear Filter</Button></Grid>
                </form>
            </Grid>
            <Toolbar
                className={clsx(classes.root, {
                    [classes.highlight]: numSelected > 0,
                })}
            >
                {numSelected > 0 ? (
                    <Typography className={classes.selectedText} color="inherit" variant="subtitle1" component="div">
                        {numSelected} selected
                    </Typography>
                ) : (
                        <Typography className={classes.title} variant="h1" id="tableTitle" component="div">
                            ePub Management
                        </Typography>
                    )}

                {numSelected > 0 ? (
                    <>
                        <Tooltip title="Delete">
                            <IconButton aria-label="delete" onClick={handleDeleteEPub}>
                                <DeleteIcon />
                            </IconButton>
                        </Tooltip>
                        {numSelected === 1 ? <>
                            <Tooltip title="Feature Book on Footer">
                                <IconButton aria-label="feature" onClick={handleFeatureEpub}>
                                    <StarIcon color={featured ? "primary" : "action"} />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Sync">
                                <IconButton aria-label="sync" onClick={handleSyncEPub}>
                                    <SyncIcon />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="View Topics">
                                <IconButton aria-label="sync" onClick={handleViewTopics}>
                                    <LaunchIcon />
                                </IconButton>
                            </Tooltip>
                            {/* <Tooltip title="ReUpload ePUB">
                                <IconButton aria-label="delete" onClick={handleReUploadEPub}>
                                    <RestorePageIcon />
                                </IconButton>
                            </Tooltip> */}
                        </> : null}

                    </>
                ) : (
                        <>
                            {/* <Tooltip title="Sync ePUB">
                                <IconButton onClick={handleSyncAllEPub}>
                                    <SyncIcon className={classes.addIcon} />
                                </IconButton>
                            </Tooltip> */}
                            <Tooltip title="Add ePUB">
                                <IconButton onClick={handleAddEPub}>
                                    <LibraryAddIcon className={classes.addIcon} />
                                </IconButton>
                            </Tooltip>
                        </>
                    )}
            </Toolbar>
        </>
    );
};

EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
};

export default EnhancedTableToolbar;